import { render, staticRenderFns } from "./FormContainerMoving.vue?vue&type=template&id=0628d684"
import script from "./FormContainerMoving.vue?vue&type=script&lang=js"
export * from "./FormContainerMoving.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports